export function updateSelectedAnswer(context, record) {
  context.gateways.selfServiceGateway.updateSelectedAnswer(record);
}

export function getAnswerSearchResults(context, record) {
  context.gateways.selfServiceGateway.getSearchResults(record);
}
